import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
function fromTimeActivityDTO(dto) {
    return {
        id: dto.id,
        date: dto.date,
        note: dto.note,
        minutes: dto.minutes,
        hours: dto.hours,
        item: _object_spread({}, dto.item),
        customer: _object_spread({}, dto.customer),
        class: dto.class ? _object_spread({}, dto.class) : undefined,
        url: dto.url
    };
}
export class TimeActivitiesModel {
    static fromDTO(dto) {
        const services = {};
        dto.forEach((item)=>{
            services[item.serviceId] = item.timeActivities.map(fromTimeActivityDTO);
        });
        return new TimeActivitiesModel(services);
    }
    getServices() {
        return this.services;
    }
    getTimeActivitiesForService(serviceId) {
        return this.services[serviceId || ''] || [];
    }
    hasServices() {
        return Object.keys(this.services).length > 0;
    }
    constructor(services = {}){
        _define_property(this, "services", void 0);
        this.services = services;
    }
}
